import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Filter icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Filter } from '@sravni/design-system-icons'
 *
 * <Filter />
 * ```
 */
var Filter = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Filter", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.237 8.763a1.75 1.75 0 1 0-2.474 2.474 1.75 1.75 0 0 0 2.474-2.474ZM11.763 6.237a1.75 1.75 0 1 0 2.474-2.474 1.75 1.75 0 0 0-2.474 2.474ZM11.763 16.237a1.75 1.75 0 1 0 2.474-2.474 1.75 1.75 0 0 0-2.474 2.474Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.25 4.5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5ZM17.25 9.5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5ZM11.25 14.5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5ZM17.25 4.5h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5ZM5.25 9.5h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5ZM17.25 14.5h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5Z", fill: "currentColor" }))); });

export { Filter };
//# sourceMappingURL=Filter.js.map
